import { getExerciseTypeVersionAdapter, LATEST_SCHEMA_VERSION } from '@datacamp/exercise-types';
const exerciseTypeVersionAdapter = getExerciseTypeVersionAdapter('DatalabExercise', LATEST_SCHEMA_VERSION.DatalabExercise);
export default exerciseTypeVersionAdapter;